import React, { useRef } from 'react';
import SvgIcon from '../SvgIcon/SvgIcon';
import { IconName } from '../../assets/icons';

interface FileUploaderProps {
  currentFile: File | null;
  onFileChange: (file: File | null) => void;
  onRemoveFile?: () => void;
  onClearState?: () => void;
  label?: string;
  accept?: string;
  iconKey?: IconName; // Ex: 'upload', 'file-text', 'html', etc.
  disabled?: boolean;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  currentFile,
  onFileChange,
  onRemoveFile,
  onClearState,
  label = 'Archivo',
  accept = '*/*',
  iconKey = 'upload',
  disabled = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    onFileChange(file);
  };

  const handleRemove = () => {
    if (inputRef.current) inputRef.current.value = '';
    onFileChange(null);
    if (onRemoveFile) onRemoveFile();
    if (onClearState) onClearState();
  };

  return (
    <div className="mb-6">
      {label && (
        <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-white">
          {label}
        </label>
      )}

      <div className="relative flex items-center">
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          disabled={disabled}
          className="w-full cursor-pointer rounded-lg border-[1.5px] border-stroke bg-transparent px-4 py-3 text-sm outline-none transition file:mr-5 file:cursor-pointer file:rounded file:border-0 file:bg-primary file:px-5 file:py-2 file:text-white file:transition file:hover:bg-opacity-90 focus:border-primary active:border-primary disabled:cursor-not-allowed disabled:opacity-50 dark:border-form-strokedark dark:bg-form-input dark:file:bg-white/30 dark:file:text-white dark:focus:border-primary"
          onChange={handleFileChange}
        />

        {/* Icono visual a la derecha */}
        {iconKey && (
          <div className="absolute right-4 top-1/2 -translate-y-1/2 transform text-primary">
            <SvgIcon name={iconKey} />
          </div>
        )}
      </div>

      {/* Info del archivo seleccionado */}
      {currentFile && (
        <div className="mt-2 flex items-center justify-between text-sm text-gray-600 dark:text-gray-300">
          <span>
            Archivo seleccionado: <strong>{currentFile.name}</strong>
          </span>
          <button
            type="button"
            onClick={handleRemove}
            className="ml-4 rounded bg-meta-1 px-3 py-1.5 text-xs font-medium text-white hover:bg-opacity-90"
          >
            Quitar
          </button>
        </div>
      )}
    </div>
  );
};

export default FileUploader;
